import windowFeedback from './feedback';

export { windowFeedback };